export default __webpack_public_path__ + "static/media/home.fc90931b.svg";